<template>
  <section class="r-items-holder-page">
    <v-tabs
      v-model="tab"
      background-color="blue-grey lighten-5"
    >
      <v-tab key="item_page">Items</v-tab>
      <v-tab key="item_kind">Kind</v-tab>
      <v-tab key="item_group">Group</v-tab>
      <v-tab key="item_shop">Shop</v-tab>
      <v-tab key="item_offer">Offer</v-tab>
      <v-tab key="item_order">Order</v-tab>
      <v-tab key="item_addon">Addon</v-tab>
      <v-tab key="item_recipe">Recipe</v-tab>
      <v-tab key="item_cluster">Cluster</v-tab>
      <v-tab key="item_social">Social</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" class="mt-4">
      <v-tab-item key="item_page">
        <r-item-page/>
      </v-tab-item>
      <v-tab-item key="item_kind">
        <r-item-kind-page/>
      </v-tab-item>
      <v-tab-item key="item_group">
        <r-item-group-page/>
      </v-tab-item>
      <v-tab-item key="item_shop">
        <r-item-shop-page/>
      </v-tab-item>
      <v-tab-item key="item_offer">
        <r-item-offer-page/>
      </v-tab-item>
      <v-tab-item key="item_order">
        <r-item-order-page/>
      </v-tab-item>
      <v-tab-item key="item_addon">
        <r-item-addon-page/>
      </v-tab-item>
      <v-tab-item key="item_recipe">
        <r-item-recipe-page/>
      </v-tab-item>
      <v-tab-item key="item_cluster">
        <r-item-cluster-page/>
      </v-tab-item>
      <v-tab-item key="item_social">
        <r-item-social-page/>
      </v-tab-item>
    </v-tabs-items>
  </section>
</template>

<script>
import RItemPage from "@/modules/redactor/views/item/r-item-page.vue";
import RItemKindPage from "@/modules/redactor/views/item-kind/r-item-kind-page.vue";
import RItemGroupPage from "@/modules/redactor/views/item-group/r-item-group-page.vue";
import RItemShopPage from "@/modules/redactor/views/item-shop/r-item-shop-page.vue";
import RItemOfferPage from "@/modules/redactor/views/item-offer/r-item-offer-page.vue";
import RItemOrderPage from "@/modules/redactor/views/item-order/r-item-order-page.vue";
import RItemAddonPage from "@/modules/redactor/views/item-addon/r-item-addon-page.vue";
import RItemRecipePage from "@/modules/redactor/views/item-recipe/r-item-recipe-page.vue";
import RItemClusterPage from "@/modules/redactor/views/item-cluster/r-item-cluster-page.vue";
import RItemSocialPage from "@/modules/redactor/views/items-social/r-item-social-page.vue";

export default {
  name: "r-items-holder-page",
  components: {
    RItemPage,
    RItemKindPage,
    RItemGroupPage,
    RItemShopPage,
    RItemOfferPage,
    RItemOrderPage,
    RItemAddonPage,
    RItemRecipePage,
    RItemClusterPage,
    RItemSocialPage
  },
  data: () => ({
    tab: null
  })
}

</script>